import { Client } from "typesense";

export const typesenseClient = new Client({
    nodes: [{
        host: import.meta.env.VITE_TYPESENSE_URL,
        port: import.meta.env.VITE_TYPESENSE_PORT,
        protocol: import.meta.env.VITE_TYPESENSE_PROTOCOL
    }],
    apiKey: import.meta.env.VITE_TYPESENSE_API_KEY,
    connectionTimeoutSeconds: 20
});